<template>
  <div>
    <Login @login_close="login_close" v-if="login_show"></Login>
    <div id="root">
      <div class="bigbox_left">
        <router-link to="IndexValuation" class="left_menu1">
          <div><img src="../../public/img/main/left_zsgd.png" alt="" /></div>
          <div class="link_a">指数估值</div>
        </router-link>

        <router-link to="PlateTheme" class="left_menu1">
          <div><img src="../../public/img/main/left_bkzt.png" alt="" /></div>
          <div class="link_a">板块主题</div>
        </router-link>

        <router-link to="InformationCommunity" class="left_menu1">
          <div><img src="../../public/img/main/left_zxsq.png" alt="" /></div>
          <div class="link_a">资讯社区</div>
        </router-link>

        <router-link to="SmartStock" class="left_menu1">
          <div><img src="../../public/img/main/left_zxg.png" alt="" /></div>
          <div class="link_a">智选股</div>
        </router-link>

        <router-link to="SmartFund" class="left_menu1">
          <div><img src="../../public/img/main/left_zxj.png" alt="" /></div>
          <div class="link_a">智选基</div>
        </router-link>

        <router-link to="CopyOperation" class="left_menu1">
          <div><img src="../../public/img/main/left_czy.png" alt="" /></div>
          <div class="link_a">抄作业</div>
        </router-link>
        <div class="left_menu2">
          <div style="cursor: pointer">
            <div><img src="../../public/img/main/left_app.png" alt="" /></div>
            <div>下载app</div>
          </div>
          <div style="margin-top: 24px; cursor: pointer">
            <div>
              <img src="../../public/img/main/left_weixin.png" alt="" />
            </div>
            <div>关注钱术</div>
          </div>
        </div>
      </div>

      <div class="bigbox_content">
        <router-view />
        <div class="big_bottom_warning">
          小钱书&钱术的内容基于大数据智能生产，不构成投资建议，风险自担。
        </div>
      </div>

      <Right :route='route'></Right>

      <div class="bigbox_top_title">
        <div class="top_left">
          <div class="top_left_img" @click="gotoindex">
            <img
              class="top_left_img_img1"
              src="../../public/img/main/logo.png"
              alt=""
            />
            <img
              class="top_left_img_img2"
              src="../../public/img/main/top_qszt.png"
              alt=""
            />
          </div>
          <div class="top_left_menu">
            <div
              class="top_left_menu_text1"
              :class="{ top_left_menu_text2: top_menu_type == 0 }"
              @click="chang_menu_type(0)"
            >
              股票
            </div>
            <div
              class="top_left_menu_text1"
              :class="{ top_left_menu_text2: top_menu_type == 1 }"
              @click="chang_menu_type(1)"
            >
              基金
            </div>
            <div
              class="top_left_menu_text1"
              :class="{ top_left_menu_text2: top_menu_type == 2 }"
              @click="chang_menu_type(2)"
            >
              固收
            </div>
          </div>
          <div class="top_left_input">
            <input type="text" placeholder="代码/拼音/名称" /><img
              src="../../public/img/main/top_ss.png"
              alt=""
            />
          </div>
        </div>
        <div class="top_right">
          <div class="top_right_div1">
            <img src="../../public/img/main/left_app.png" alt="" />
            APP下载
          </div>
          <div class="top_right_div2">
            <img src="../../public/img/main/left_weixin.png" alt="" />
            关注钱术
          </div>
          <div class="top_right_div3" >
            <img :src="img_head" alt="" style="width:50px;height:50px;" v-show="img_head"/>
            <i v-if="!islogin" @click="login">登陆/注册</i>
            <i v-else @click="outlogin">退出登录</i>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Login from "../components/login.vue";
import Right  from "../components/right.vue" 
export default {
  data() {
    return {
      login_show: false, //登陆弹框的出现/隐藏
      top_menu_type: 0, //顶部   股票，基金，固收 的样式切换
      route:'',
      
    };
  },
  computed:{
    islogin(){
      return localStorage.getItem('sign') || localStorage.getItem('userinfo')
    },
    img_head(){
      let canshu = JSON.parse(localStorage.getItem('userinfo'))
      return canshu && canshu.head_img || ''
    }
  },
  components: {
    Login,
    Right
  },
  mounted(){
    let router_path = this.$route.path
    console.log(router_path);
    if(router_path == '/stock/'){
      this.top_menu_type = 0
    }else if(router_path == '/fund/'){
      this.top_menu_type = 1
    }else if(router_path == '/gushou/'){
      this.top_menu_type = 2
    }
  },
  methods: {
    gotoindex(){
      this.$router.push({path:'/stock/'})
      this.top_menu_type = 0
    },
    outlogin(){

      this.$store.commit('changeUserinfo', '')
			this.$store.commit('setSign', '')
      localStorage.removeItem('sign')
      localStorage.removeItem('userinfo')
      this.$router.go(0)
    },
    // 登陆弹框关闭
    login_close() {
      this.login_show = false;
    },
    //点击登录按钮
    login() {
      this.login_show = true;
    },
    //top menu 点击切换样式
    chang_menu_type(e) {
      this.top_menu_type = e;
      if(e == 0){
        this.$router.push({path:'/stock/'})
      }else if(e==1){
        this.$router.push({path:'/fund/'})
      }else if(e==2){
        this.$router.push({path:'/gushou/'})
      }
    },

  },
};
</script>


<style>
* {
  margin: 0;
  padding: 0;
}
i{
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.link_a {
  text-decoration: none;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  /* line-height: 88px; */
  letter-spacing: 0px;
  color: #ffffff;
}
#root {
  display: flex !important;
  background: #f3f3f3;
}
.bigbox_left {
  height: calc(100vh - 72px);
  max-width: 80px;
  min-width: 80px;
  min-height: 670px;
  min-height: 820px;
  position: relative;
  overflow: hidden;
  background-color: #0f0f0f;
  text-align: center;
  margin-top: 72px;
}
.left_menu1 {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  margin-top: 24px;
  text-decoration: none;
}
.left_menu1 img {
  width: 24px;
  height: 24px;
}
.left_menu2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  position: absolute;
  bottom: 200px;
  font-size: 12px;
  color: #ffffff;
}
.bigbox_top_title {
  width: 100%;
  height: 72px;
  background-color: #0f0f0f;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-content: center;
  justify-content: space-between;
  z-index: 9;
}
.top_left {
  width: 720px;
  min-width: 720px;
  max-width: 720px;
  display: flex;
  align-content: center;
  justify-content: space-around;
}
.top_left_img {
  text-align: center;
  line-height: 72px;
}
.top_left_img_img2 {
  width: 100px;
  height: 25px;
  vertical-align: middle;
}
.top_left_img_img1 {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 8px;
}
.top_left_menu {
  width: 150px;
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.top_left_menu_text1 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 72px;
  letter-spacing: 0px;
  color: #ffffff;
  cursor: pointer;
}
.top_left_input {
  width: 340px;
  height: 60px;
  border-radius: 3px;
  position: relative;
}
.top_left_input input {
  width: 306px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 3px;
  border: none;
  margin-top: 21px;
  padding-left: 34px;
}
.top_left_input input ::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 14px;
  color: #b9b9b9;
}
.top_left_input input:focus {
  outline: none;
}
.top_left_menu_text2 {
  color: #fcad2a;
}
.top_left_input img {
  position: absolute;
  top: 27px;
  left: 12px;
  width: 16px;
  height: 16px;
}
.top_right {
  width: 400px;
  min-width: 400px;
  max-width: 400px;
  display: flex;
  align-content: center;
  justify-content: space-around;
  font-size: 16px;
  color: #ffffff;
  line-height: 72px;
  margin-right: 10px;
  margin-left: 24px;
}
.top_right img {
  vertical-align: middle;
}
.top_right_div3 img {
  border-radius: 50%;
}
.top_right_div1 {
  cursor: pointer;
}
.top_right_div2 {
  cursor: pointer;
}
.top_right_div3 {
  cursor: pointer;
}
.bigbox_content {
  width: calc(100% - 380px);
  height: calc(100vh - 96px);
  min-height: 670px;
  min-height: 770px;
  margin-top: 72px;
  padding: 24px 24px 0 24px;
  overflow-y: scroll;
  position: relative;
}
.big_bottom_warning {
  width: calc(100% - 380px);
  height: 30px;
  background-color: #f3f3f3;
  line-height: 30px;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 80px;
  font-size: 14px;
  color: #b6b6b6;
}
</style>
